export default __webpack_public_path__ + "e4a9688e4de89a84d78004e781a5f562.png";